import React, { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import Footer from "./components/Footer";
import "./App.css";
import About from "./pages/About";
import Academics from "./pages/Academics";
import Admission from "./pages/Admission";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import VisionMission from "./pages/VisionMission";
import ChairmanDesk from "./pages/ChairmanDesk";
import SecretaryMessage from "./pages/SecretaryMessage";
import PrincipalDesk from "./pages/PrincipalDesk";
import SisterInstitutions from "./pages/SisterInstitutions";
import ScienceCategory from "./pages/ScienceCategory";
import ArtsCategory from "./pages/ArtsCategory";
import CommerceCategory from "./pages/CommerceCategory";
import AgriculturalCategory from "./pages/AgriculturalCategory";
import Laboratory from "./pages/Laboratory";
import TeachingStaff from "./pages/TeachingStaff";
import NonTeachingStaff from "./pages/NonTeachingStaff";
import Library from "./pages/Library";
import ArtsAndCraft from "./pages/ArtsAndCraft";
import Canteen from "./pages/Canteen";
import GirlsHostel from "./pages/GirlsHostel";
import SEO from "./components/SEO";
import seoData from "./seoData";
import HomePopup from "./pages/HomePopup";
import popupImg from "../src/assets/poster.jpg.jpeg";

// ── Home page popup (poster) ──
const SHOW_POPUP = true; // popup band karna ho to false kar do
const POPUP_LINK = "https://bihanishikshatrust.com/olympiad";

function SitePopup() {
  const location = useLocation();
  const [open, setOpen] = useState(SHOW_POPUP);
  const close = useCallback(() => setOpen(false), []);

  // Sirf home page par dikhega
  if (!open || location.pathname !== "/") return null;

  return (
    <HomePopup
      image={popupImg}
      link={POPUP_LINK}
      buttonText="Tap to Register"
      onClose={close}
    />
  );
}

// ── Har page ka title / description ──
function PageSEO() {
  const location = useLocation();
  const path = location.pathname.length > 1
    ? location.pathname.replace(/\/+$/, "")
    : "/";
  const seo = seoData[path];

  return seo
    ? <SEO title={seo.title} description={seo.description} path={path} />
    : <SEO title="Page Not Found | Seth G.L. Bihani S.D. Sr. Sec. School" path={path} noindex />;
}

function App() {
  return (
    <BrowserRouter>
      <PageSEO />
      <SitePopup />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            {/* Main Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/admission" element={<Admission />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/vision" element={<VisionMission />} />
            <Route path="/chairman" element={<ChairmanDesk />} />
            <Route path="/secretary" element={<SecretaryMessage />} />
            <Route path="/principal" element={<PrincipalDesk />} />
            <Route path="/sister" element={<SisterInstitutions />} />
            <Route path="/science" element={<ScienceCategory />} />
            <Route path="/arts" element={<ArtsCategory />} />
            <Route path="/commerse" element={<CommerceCategory />} />
            <Route path="/agri" element={<AgriculturalCategory />} />
            <Route path="/Laboratory" element={<Laboratory />} />
            <Route path="/teaching" element={<TeachingStaff />} />
            <Route path="/nonteaching" element={<NonTeachingStaff />} />
            <Route path="/library" element={<Library />} />
            <Route path="/canteen" element={<Canteen />} />
            <Route path="/hostel" element={<GirlsHostel />} />
            <Route path="/artandcraft" element={<ArtsAndCraft />} />

            {/* Purane sub-routes asli pages pe redirect */}
            <Route path="/academics/science" element={<Navigate to="/science" replace />} />
            <Route path="/academics/commerce" element={<Navigate to="/commerse" replace />} />
            <Route path="/academics/arts" element={<Navigate to="/arts" replace />} />

            {/* 404 Route */}
            <Route path="*" element={
              <div style={{ padding: "40px 20px", textAlign: "center" }}>
                <h1>Page Not Found</h1>
                <a href="/">Home pe jaayein</a>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;